import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { ItemPickerOption } from './models/itemPickerOption';

@Component({
  selector: 'item-picker',
  templateUrl: './item-picker.component.html',
  styleUrls: ['./item-picker.component.scss'],
  standalone: false
})
export class ItemPickerComponent implements OnInit {
  @Input() data: ItemPickerOption[] = [];

  @Output() select = new EventEmitter();

  @Output() create = new EventEmitter();

  @Input() type: string;

  @Input() enableSelector: boolean = false;

  @Input() placeholder: string;

  @Input() selectedValue: ItemPickerOption;

  @Input() disabled: boolean = false;
  @Input() showCreateButton: boolean = false;
  @Input() createButtonText: string = 'Create';
  @Input() hasError: boolean = false;
  @Input() required: boolean = false;
  @Input() errorMessage: string = 'This field is required';

  @Input() smallSize: boolean = false;
  @Input() label: string = null;

  @ViewChild('searchInput') searchInput: ElementRef<HTMLInputElement>;

  search = '';
  disabledSelector = false;

  constructor() {}

  ngOnInit(): void {
    if (this.type == 'button') {
      this.disabledSelector = true;
    }
  }
  copySelected() {
    if (this.selectedValue) {
      this.select.emit(this.selectedValue);
    }
  }
  onClick(item: ItemPickerOption) {
    this.select.emit(item);
  }

  keyup() {
    let selectedItem = document.querySelector('.mat-active') as any;
    if (selectedItem) {
      selectedItem.focus();
    }
  }

  onSearchKeydown(event: KeyboardEvent) {
    if (event.key !== 'Escape') {
      event.stopPropagation();
    }
  }

  openSelector(selector) {
    this.disabledSelector = false;
    setTimeout(() => {
      selector.open();
    }, 0);
  }

  selectorClosed() {
    this.search = '';
    if (this.type == 'button') {
      this.disabledSelector = true;
    }
  }

  selectorOpened() {
    setTimeout(() => {
      this.searchInput?.nativeElement.focus();
    }, 0);
    if (this.type == 'button') {
      let selectedOption = document.querySelector('.mat-selected');
      if (!selectedOption) return;
      selectedOption.classList.remove('mat-selected', 'mat-active');
    }
  }
}
